module.exports = __webpack_public_path__ + "static/media/PU3040F0.7c96e558.png";